import VehicleReservationComponent from '../../../../../components/vehicle-reservation/vehicle-reservation';
import VehicleReservation from './index';

export default VehicleReservation(VehicleReservationComponent);
